<template>
  <b-row>
    <b-colxx class="disable-text-selection">
      <b-row>
        <b-colxx xxs="12">
          <h1>{{ $t('menu.goods-list') }}</h1>
          <piaf-breadcrumb/>
          <div class="separator mb-5"/>
        </b-colxx>
      </b-row>

      <b-card style="display: block;">
        <b-row class="mb-4">
          <b-colxx xxs="10" md="6" lg="4">
            <div class="has-float-label">
              <b-input-group class="mb-3">
                <b-input placeholder="상품명을 검색하세요" v-model="search" @keyup.enter="searchKeyword"/>
                <b-button v-show="!searchFlag" @click="searchKeyword" variant="outline-primary default" size="sm">
                  {{ $t('button.search') }}
                </b-button>
                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary default" size="sm">
                  {{ $t('button.search-cancel') }}
                </b-button>
              </b-input-group>
              <span>상품명</span>
            </div>
          </b-colxx>
          <b-colxx xxs="2" md="6" lg="8">
            <div class="float-md-right pt-1">
              <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-primary" class="d-inline-block"
                          size="md">
                <b-dropdown-item v-for="(size,index) in pageSizes" :key="index" @click="changePageSize(size)">
                  {{ size }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-colxx>
        </b-row>

        <template v-if="isLoad">
          <b-row>
            <b-colxx sm="6" lg="4" xl="4" xxl="4" class="mb-3" v-for="(item,index) in items" :key="index"
                     :id="item.registerId">

              <b-card style="display: block;" no-body>
                <div class="position-relative">
                  <img style="width: 100%; height :230px; object-fit: cover;" :src="item.mainImageUrl"
                       class="card-img-top" :alt="item.goodsName"/>
                </div>
                <h4>
                  <b-badge pill variant="primary" class="position-absolute badge-top-left">
                    {{ goodsTypeOption[item.goodsType] }}
                  </b-badge>
                </h4>

                <b-card-body>
                  <b-row>
                    <b-colxx xxs="10" class="mb-1">
                      <h6 class="mb-4 card-subtitle goodsName">{{ item.goodsName }}</h6>
                    </b-colxx>
                  </b-row>


                  <b-row class="">
                    <b-colxx xxs="3" md="3" xxl="3" style="padding-top: 5px;">판매상태:</b-colxx>
                    <b-colxx xxs="6" md="6" xxl="6" align="left" class="pl-0">
                      <toggle-button v-model="item.onSale" :value="true" :sync="true"
                                     :labels="{checked: '판매중', unchecked: '판매종료'}"
                                     :color="{checked: '#c11314', unchecked: '#bfcbd9'}"
                                     @change="changeStatus(item)"
                                     :width="80" :height="30"/>
                    </b-colxx>
                    <b-colxx xxs="3" md="3" xxl="3" >
                      <div class="textBtn1" size="sm" @click="individualOption(item)">옵션종료</div>
                    </b-colxx>
                  </b-row>


                  <b-row class="mt-1">
                    <b-colxx xxs="3" md="3" xxl="3"  class="pt-2">대표옵션:</b-colxx>
                    <b-colxx xxs="6" md="6" xxl="6" align="left"  class="pt-2 pl-0 goodsOption">
                      {{ item.mainOption.optionName }}
                    </b-colxx>
                    <b-colxx xxs="3" md="3" xxl="3"  class="pt-2">
                      <div v-if="item.mainOption.optionName" @click="representativeOption(item)" class="textBtn1">변경</div>
                    </b-colxx>
                  </b-row>


                  <b-row class="mt-3">
                    <b-colxx align="center">
                      <b-button variant="outline-primary default" size="sm" @click="copyItem(item)">상품복사</b-button>
                      <b-button variant="primary default" size="sm" @click="modifyItem(item)">상품정보수정</b-button>
                      <!--                      <b-button variant="primary default" size="sm" @click="clickItem(item)">상품보기</b-button>-->
                      <!-- <b-button variant="outline-primary default" size="sm" @click="deleteItem(item)">
                        <b-icon icon="trash" scale="1.8"></b-icon>
                      </b-button> -->
                    </b-colxx>
                  </b-row>


                </b-card-body>
              </b-card>
            </b-colxx>

            <b-colxx xxx="12" class="mb-3" v-if="items.length === 0 ">
              <b-card :class="{'d-flex flex-row':true }" no-body>
                <div class="pl-2 d-flex flex-grow-1 min-width-zero">
                  <div
                    class="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                    <h4 style="text-align:center;width:100%">조회 내용이 없습니다.</h4>
                  </div>
                </div>
              </b-card>
            </b-colxx>
          </b-row>

          <b-row v-if="lastPage > 1">
            <b-colxx xxs="12">
              <b-pagination
                size="sm"
                align="center"
                :total-rows="total"
                :per-page="perPage"
                v-model="currentPage"
              >
                <template v-slot:next-text>
                  <i class="simple-icon-arrow-right"/>
                </template>
                <template v-slot:prev-text>
                  <i class="simple-icon-arrow-left"/>
                </template>
                <template v-slot:first-text>
                  <i class="simple-icon-control-start"/>
                </template>
                <template v-slot:last-text>
                  <i class="simple-icon-control-end"/>
                </template>
              </b-pagination>

            </b-colxx>
          </b-row>
        </template>
        <template v-else>
          <div class="loading"></div>
        </template>
      </b-card>
    </b-colxx>
  </b-row>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {ToggleButton} from 'vue-js-toggle-button'
import api from '../../constants/api'
import {
  mapGetters,
  mapActions
} from "vuex";

import ImageListItem from '../../components/Listing/ImageListItem'
import {
  apiUrl
} from '../../constants/config'

export default {
  components: {
    'v-select': vSelect,
    'image-list-item': ImageListItem,
    'toggle-button': ToggleButton
  },
  data() {
    return {
      isLoad: false,
      search: '',
      searchFlag: false,
      currentPage: 1,
      perPage: 6,
      total: 0,
      lastPage: 0,
      items: [],
      pageSizes: [6, 9,12],
      sortBy: 'RegDate',
      direction: 'Descending',
      statusOptions: {'NoRequest': '임시저장', 'Requested': '승인요청', 'RequestDenied': '승인거절', 'RequestApprove': '승인완료'},
      goodsTypeOption: {'Booking': '예약', 'BookingCoupon': '예약권', 'MobileCoupon': '모바일쿠폰'}

    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName'])
  },

  watch: {
    currentPage() {
      this.searchData()
    }
  },

  mounted() {
    this.searchData()
  },

  methods: {
    ...mapActions(['deleteGoods', 'goodsInfo']),

    //상품 리스트 조회
    searchData() {
      this.isLoad = false

      let keywordType = 'GoodsNameContaining'
      if(this.search == '')
        keywordType = 'NoKeyword'

      const params = {
        keywordType: keywordType,
        keyword: this.search,
        pageNumber: this.currentPage - 1,
        pageSize: this.perPage,
        all: true,
        onSale: true
      }

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.goods.page)
      this.$http.get(reqURL, {
        params: params,
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {

          const _data = res.data.data
          this.total = _data.totalElements
          this.lastPage = _data.totalPages
          this.perPage = _data.size
          this.items = _data.content;

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })

      this.isLoad = true
    },


    changeToggleButtonValue(status) {
      let value = false
      if(status == 'OnSale') {
        value = true
      }
      return value
    },


    //판매중/판매종료 토글버튼
    changeStatus(item) {
      console.log(item.onSale)

      let reqURL = ''
      if(item.onSale == true) { //판매재개
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.goods.resumeSales)
      } else { //판매중지
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.goods.stopSales)
      }
      const params = {goodsId: item.goodsId}

      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {


        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })


    },

    //개별옵션종료
    individualOption(item) {
      this.$router.push(`individual-option/${item.goodsId}`)
    },


    //대표옵션수정
    representativeOption(item) {
      this.$router.push(`representative-option/${item.goodsId}`)
    },

    //상품복사
    copyItem(item) {
      this.$router.push(`goods-copy-request/${item.goodsId}`)
    },

    //상품수정
    modifyItem(item) {
      // this.$router.push(`goods-register-request/${item.goodsId}`)
      this.$router.push(`goods-edit-request/${item.goodsId}`)
    },

    //상품보기
    clickItem(event, itemId) {
      // this.$router.push('goods-register-request')
      console.log("클릭시, 상품 상세 URL 로 이동합니다. \n" +
        "레스토랑 자체 홈페이지에 노출되는 화면으로 이동")
    },

    //상품삭제
    deleteItem(item) {
      console.log(item)
      if(confirm('상품 삭제시 이전 정보는 복구될 수 없습니다. 삭제하시겠습니까?')) {
        this.deleteGoods({currentUser: this.currentUser, siteName: this.siteName, registerId: item.goodsId})
        this.$router.go(0)

      }

    },


    //페이지당 상품갯수 수정
    changePageSize(perPage) {
      this.currentPage = 1
      this.perPage = perPage
      this.searchData()

    },

    searchKeyword() {
      // if(this.search === null | this.search === "") {
      //   alert('상품명을 입력해주세요');
      //   return false
      // }
      this.searchData()
      // this.searchFlag = true
    },
    searchCancel() {
      this.search = ''
      this.searchFlag = false
      this.searchData()
    }
  }
}
</script>
<style>
.goodsName {
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: keep-all;
  min-height: 38.39px;
}
.goodsOption {
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: keep-all;
  min-height: 51.19px;
}
</style>
